<ng-container *ngIf="component">
    <div [ngClass]="component?.textPosition === 'right' && (client.isX || client.isL) ? 'flex-reverse' : ''"
         class="flex flex-column-reverse-s flex-column-reverse-m wrap">
        <div class="w-6 w-12-s w-12-m flex flex-middle"
             [ngClass]="component?.textPosition === 'right' ? 'p-l-10-l p-l-10-x' : 'p-r-10-l p-r-10-x'">

            <text [style.list-style]="'inside'"
                  [variant]="component.textComponentVariat || 'default'"
                  class="w-12-m w-12-s"
                  [ngClass]="component.alignment === 'center' && 'c-8 m-b-0 c-12-m c-12-s'"
                  [content]="component"></text>
        </div>
        <div class="w-6 w-12-s w-12-m m-b-5-m m-b-5-s">
            <div class="video-component overflow-hidden b-radius-4"
                 [ngClass]="[component.ratio || 'ratio-2-1']">

                <!-- image -->
                <ng-container *ngIf="component?.backgroundImage">
                    <shell></shell>
                    <img class="z-1"
                         [fill]="true"
                         [ratio]="component.ratio || 'ratio-2-1'"
                         [dfImage]="component?.backgroundImage">
                </ng-container>

                <ng-container *ngIf="component.videoId">
                    <youtube-player class="z-2"
                                    [class.rf]="!!component.ratio"
                                    [video-id]="component.videoId"
                                    [autoplay-in-viewport]="component.videoAutoplay"
                                    [background]="component.videoBackground"
                                    *ngIf="component?.videoProvider === 'youtube'">
                        <!-- play icon -->
                        <ng-template #playButton>
                            <i class="icon-play"></i>
                        </ng-template>

                        <!-- pause icon -->
                        <ng-template #pauseButton>
                            <i class="icon-pause"></i>
                        </ng-template>
                    </youtube-player>

                    <vimeo-player class="z-2"
                                  [class.rf]="!!component.ratio"
                                  [video-id]="component.videoId"
                                  [autoplay-in-viewport]="component.videoAutoplay"
                                  [background]="component.videoBackground"
                                  *ngIf="component?.videoProvider === 'vimeo'">
                        <!-- play icon -->
                        <ng-template #playButton>
                            <i class="icon-play"></i>
                        </ng-template>

                        <!-- pause icon -->
                        <ng-template #pauseButton>
                            <i class="icon-pause"></i>
                        </ng-template>
                    </vimeo-player>
                </ng-container>
            </div>

        </div>
    </div>


</ng-container>
